import { DEFAULT_BORDER } from 'constants/global';

import Inline from 'assets/icons/companiesLogos/inline.svg';
import Fsk from 'assets/icons/companiesLogos/fsk.svg';
import Omk from 'assets/icons/companiesLogos/omk.svg';
import Tit from 'assets/icons/companiesLogos/tit.svg';

const cardsData = [
  {
    companyIcon: Inline,
    text: 'Команда АСТОН зарекомендовала себя как профессионалы своего дела. Качество предоставляемых услуг неизменно находится на высоком уровне, что подтверждает профессионализм сотрудников, их клиентоориентированность и способность закрыть даже самую сложную потребность',
    name: 'А. И. Ромашкин',
    position: 'Генеральный директор АО «ИНЛАЙН ГРУП»',
    pdfLink: 'inline_group',
  },
  {
    companyIcon: Fsk,
    text: 'ООО «АСТОН» показало свою способность с высокой ответственностью подойти к поставленной задаче, выполнить работу своевременно и качественно, в строгом соответствии с договорными условиями. ГК «ФСК» рекомендует ООО «АСТОН» как надёжного делового партнёра',
    name: 'Д. М. Цыганков',
    position: 'Вице-президент по ИТ, ФСК',
    pdfLink: 'fsc',
  },
  {
    companyIcon: Omk,
    text: 'Особо хотим отметить такие аспекты сотрудничества с ООО «АСТОН», как полное соблюдение договорных обязательств, оперативность рассмотрения заявок и отзывчивость ко всем комментариям и дополнениям с нашей стороны',
    name: 'П. П. Кузин',
    position: 'Руководитель центра компетенций 1С ООО «ОМК-ИТ»',
    pdfLink: 'omk',
  },
  {
    companyIcon: Tit,
    text: 'B процессе реализации проекта команда 1С ООО «Астон» показала свой высокий профессионализм, готовность быстро адаптироваться под новые задачи в рамках проекта, умение слышать заказчика',
    name: 'Д. И. Шейнрок',
    position: 'Генеральный директор Трэйд Инвест Технолоджиз',
    pdfLink: 'tit',
  },
];

const slidesStyles = [
  { bgColor: 'bg.neonLight', iconProps: { bgSize: '60%' } },
  {
    border: DEFAULT_BORDER,
    borderColor: 'line.gray',
    iconProps: { bgSize: '65%', bgColor: 'bg.gray' },
  },
  { bgColor: 'bg.gray', iconProps: { bgSize: '70%' } },
  {
    border: DEFAULT_BORDER,
    borderColor: 'line.gray',
    iconProps: { bgSize: '70%', bgColor: 'bg.grayLight' },
  },
];

export const oneCReviewsPropsData = { cardsData, slidesStyles };
